export default __webpack_public_path__ + "static/media/icn_profile_modify.8e9b23e6.svg";